import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import AuthService from "../../service/authService";
import {
  isFrench,
  isEnglish,
  setFrench,
  setEnglish,
} from "../../utils/LocaleUtil";
import { useCurrency } from "../../utils/Currencies";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/Constant";
import DropDownMenu from "../../common/components/DropDownMenu";

const ProfileMenu = (props) => {
  const { children, menuIcon, isAdmin } = props;

  const userInfos = useSelector((state) => state.userInfo);

  const navigate = useNavigate();

  const setLanguageFrench = useCallback(() => {
    setFrench(userInfos);
    //  window.location.reload();Not needed
  }, [userInfos]);

  const setLanguageEnglish = useCallback(() => {
    setEnglish(userInfos);
    //  window.location.reload();Not needed
  }, [userInfos]);

  const { setUSD, setCAD, isCAD, isUSD } = useCurrency();

  const setUSDCurrency = () => {
    setUSD();
  };

  const setCADCurrency = () => {
    setCAD();
  };

  const logout = useCallback(async () => {
    await AuthService.logOut();

    navigate(ROUTES.LOGIN);
  }, [navigate]);

  const goToOrders = useCallback(() => {
    navigate(ROUTES.ORDERS);
  }, [navigate]);

  const goToAllOrders = useCallback(() => {
    navigate(ROUTES.ADMIN_PURCHASED_ORDERS);
  }, [navigate]);

  const goToReferralCodeValidation = useCallback(() => {
    navigate(ROUTES.ADMIN_VALIDATE_REFERRAL_CODE);
  }, [navigate]);

  const profileMenuOptions = [
    // {
    //   labelKey: "profile.my_profile",
    //   disabled: true,
    // },
    // {
    //   labelKey: "profile.refer_friend",
    //   disabled: true,
    // },
    // {
    //   labelKey: "profile.help",
    //   disabled: true,
    // },
    {
      labelKey: "profile.my_orders",
      onClick: goToOrders,
      disabled: false,
    },
    {
      labelKey: "languageDivider",
      disabled: true,
      isDivider: true,
    },
    {
      labelKey: "profile.english",
      onClick: setLanguageEnglish,
      isChecked: isEnglish(),
    },
    {
      labelKey: "profile.french",
      onClick: setLanguageFrench,
      isChecked: isFrench(),
    },
    {
      labelKey: "currencyDivider",
      disabled: true,
      isDivider: true,
    },
    {
      labelKey: "profile.usd",
      onClick: setUSDCurrency,
      isChecked: isUSD(),
    },
    {
      labelKey: "profile.cad",
      onClick: setCADCurrency,
      isChecked: isCAD(),
    },
    {
      labelKey: "lopoutDivider",
      disabled: true,
      isDivider: true,
    },
    {
      labelKey: "general.log_out",
      //icon: "delete",
      //disabled: !canDelete,
      onClick: logout,
    },
  ];

  if (isAdmin) {
    profileMenuOptions.unshift(
      {
        labelKey: "profile.all_orders",
        onClick: goToAllOrders,
        disabled: false,
      },
      {
        labelKey: "profile.validate_referral_code",
        onClick: goToReferralCodeValidation,
        disabled: false,
      },
      {
        labelKey: "adminDivider",
        disabled: true,
        isDivider: true,
      }
    );
  }

  return (
    <DropDownMenu
      menuIcon={menuIcon}
      options={profileMenuOptions}
      alignMenuRight={true}
    >
      {children}
    </DropDownMenu>
  );
};

export default ProfileMenu;
